import React from 'react';
import { useTranslation } from 'react-i18next';

export const HealthInformation: React.FC = () => {
  const { i18n } = useTranslation();

  const ContentPl: React.FC = () => (
    <div>
      <center>
        <h1>Informacje Zdrowotne</h1>
      </center>

      <ol>

        <li>
          <b>
            Insulimit sp. z o.o. nie świadczy usług medycznych.
          </b>

          <p>
            Aplikacja oraz wszelkie materiały, treści, informacje, sugestie dietetyczne,
            wskazówki dotyczące stylu życia, żywienia lub suplementacji udostępniane za
            jej pośrednictwem mają charakter wyłącznie ogólnoinformacyjny i edukacyjny.
              Żadna część Aplikacji nie stanowi porady medycznej, diagnozy, rekomendacji
            terapeutycznej ani substytutu konsultacji z lekarzem, dietetykiem lub innym
            wykwalifikowanym specjalistą ochrony zdrowia.
          </p>

          <p>
            Usługi świadczonę przez Aplikację nie stanowią usług medycznych w rozumieniu ustawy z dnia 15 kwietnia 2011 r. o działalności leczniczej.
          </p>

          <p>
            Szczegółowe warunki korzystania z Aplikacji znajdują się w Regulaminie.
          </p>
        </li>

        <li>
          <b>
          Informacje dotyczące funkcjonalności zawartych w Aplikacji.
          </b>

          <p>
            <ol>
              <li>
                Pomiary masy ciała oraz poziomu glukozy.
                <p>
                  Aplikacja nie intepretuje wartości poziomu glukozy we krwi oraz masy ciała.
                  Wprowadzone dane nie służą do diagnozowania ani monitorowania stanu zdrowia przez Aplikację.
                </p>
              </li>

              <li>
                Konfiguracja harmongramu leków i śledzenie przyjętych leków.
                <p>
                  Aplikacja nie analizuje ani nie informuje o interakcjach leków, dawkowaniu oraz zgodności z zaleceniami lekarskimi.
                  W przypadku jakichkolwiek wątpliwości należy skonsultować się z lekarzem lub farmaceutą. Diety
                </p>
              </li>

              <li>
                Wyznaczenie zapotrzebowania kalorycznego oraz wybór diety

                <p>
                  Podstawą wyznaczenia zapotrzebowania kalorycznego w Aplikacji jest podstawowa przemiana materii wyznaczona ze wzoru
                  Mifflin St Jeor. [<a href="https://en.wikipedia.org/wiki/Basal_metabolic_rate#BMR_estimation_formulas">Źródło</a>]
                </p>


                <p>
                  Ostateczne zapotrzebowanie określane jest wg wzoru:
                </p>

                <p>
                  E = 0.5 * (A + L) * (10.0m / 1 [kg] + 6.25h / 1 [cm] - 5.0a/1 [rok] + s) + T [kcal/dzień]
                </p>

                <p>
                  gdzie:<br/>

                  <table>
                    <tr>
                      <td>E</td>
                      <td>- obliczone dzienne zapotrzebowanie kaloryczne</td>
                    </tr>

                    <tr>
                      <td>A</td>
                      <td>- współczynnik aktywności fizycznej, dobierany w zależności od aktywności fizycznej</td>
                    </tr>

                    <tr>
                      <td></td>
                      <td>
                        <table>
                          <tr>
                            <td>Brak</td>
                            <td>1.2</td>
                          </tr>
                          <tr>
                            <td>Sporadyczne treningi</td>
                            <td>1.4</td>
                          </tr>
                          <tr>
                            <td>Częste treningi</td>
                            <td>1.6</td>
                          </tr>
                          <tr>
                            <td>Częste i ciężkie treningi</td>
                            <td>1.8</td>
                          </tr>
                          <tr>
                            <td>Sportowiec</td>
                            <td>2.2</td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td>L</td>
                      <td>- współczynnik stylu życia</td>
                    </tr>

                    <tr>
                      <td></td>
                      <td>
                        <table>
                          <tr>
                            <td>Praca biurowa</td>
                            <td>1.2</td>
                          </tr>
                          <tr>
                            <td>Praca mieszana</td>
                            <td>1.5</td>
                          </tr>
                          <tr>
                            <td>Praca fizyczna</td>
                            <td>1.8</td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td>m</td>
                      <td>- masa ciała [kg]</td>
                    </tr>
                    <tr>
                      <td>h</td>
                      <td>- wzrost [cm]</td>
                    </tr>
                    <tr>
                      <td>a</td>
                      <td>- wiek [lata]</td>
                    </tr>
                    <tr>
                      <td>s</td>
                      <td>- +5 u mężczyzn i -161 u kobiet</td>
                    </tr>

                    <tr>
                      <td>T</td>
                      <td>- cel dietetyczny [kcal/dzień]</td>
                    </tr>

                    <tr>
                      <td></td>
                      <td>
                        <table>
                          <tr>
                            <td>Redukcja wagi</td>
                            <td>-300</td>
                          </tr>
                          <tr>
                            <td>Utrzymanie wagi</td>
                            <td>0</td>
                          </tr>
                          <tr>
                            <td>Przybieranie na wadze</td>
                            <td>+300</td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                  </table>
                </p>


                <p>
                  Zbyt niska lub zbyt wysoka podaż kalorii może być szkodliwa dla zdrowia. Ustanowienia limitów kalorycznych, węglowodanów, tłuszczy oraz białka należy dokonać w konsultacji z lekarzem lub dietetykiem.
                  Wytyczne na temat zdrowego żywienia dostęne są na stronie Światowej Organizacji Zdrowia. [<a href="https://www.who.int/health-topics/healthy-diet#tab=tab_2">Link</a>]
                </p>

                <p>
                  Plany "Standard", "Low Carb" oraz "Keto" możliwe do wyboru w Aplikacji wpływają na wartości graniczne makroskładników w odniesieniu do wyznaczonego zapotrzebowania kalorycznego. Nie stanowią one pełnego planu żywieniowego.
                  Aplikacja umożliwia nadpisanie wartości wyznaczonych automatycznie własnymi po wyborze planu "Standard".
                </p>

                <p>
                  Ze względu na istniejące przeciwwskazania w stosowaniu diet ketogenicznej i niskowęglowodanowej, planów "Keto" i "Low Carb" nie należy stosować bez uprzedniej konsultacji z lekarzem lub dietetykiem.
                </p>
              </li>

            </ol>
          </p>
        </li>

        <li>
          <b>Źródło danych żywieniowych</b>

          <p>
            Dane dotyczące produktów zawarte w Aplikacji pochodzą z bazy Open Food Facts chyba, że wskazano inaczej [<a href="https://world.openfoodfacts.org/">Link</a>].
          </p>

          <p>
            Dokładność danych może różnić się w zależności od produktu. Insulimit sp. z o.o. nie ponosi odpowiedzialności za błędne dane.
          </p>
        </li>
      </ol>
    </div>
  )

  const ContentEn: React.FC = () => (
    <div>
      <center>
        <h1>Health Information</h1>
      </center>

      <ol>

        <li>
          <b>
            Insulimit sp. z o.o. does not provide any medical services.
          </b>

          <p>
               The Application and all materials, content, information, dietary suggestions, lifestyle,
            nutrition or supplementation tips provided through it are for general
            informational and educational purposes only. No part of the App constitutes
            medical advice, diagnosis, therapeutic recommendation or a substitute for
            consultation with a physician, dietitian or other qualified healthcare
            professional.
          </p>

          <p>
            Services provided do not constitute medical services within the meaning of the Act of 15 April 2011 on medical activities.
          </p>

          <p>
            Detailed information regarding use of the Application can be found in the Terms of Service.
          </p>
        </li>

        <li>
          <b>
          Information regarding Services included in the Application
          </b>

          <p>
            <ol>
              <li>
                Body mass and blood glucose levels measurement
                <p>
                  The Application does not interpret blood glucose level and body mass records in any way.
                  Data recorded within the Application aren't used to diagnose nor monitor health by the Application.
                </p>
              </li>

              <li>
                Medicine intake harmonogram and tracking of medicine intake

                <p>
                  In case of any doubt, a consultation with doctor or a pharmacist is required.
                </p>
              </li>

              <li>
                Daily caloric intake and diet choice calculation

                <p>

                  The basis for daily caloric intake calculation in the Application is basal metabolic rate, calculated according to the Mifflin St Jeor formula. [<a href="https://en.wikipedia.org/wiki/Basal_metabolic_rate#BMR_estimation_formulas">Source</a>]
                </p>

                <p>
                  Total daily caloric intake is calculated according to the following formula:
                </p>

                <p>
                  E = 0.5 * (A + L) * (10.0m / 1 [kg] + 6.25h / 1 [cm] - 5.0a/1 [year] + s) + T [kcal/day]
                </p>

                <p>
                  where:<br/>

                  <table>
                    <tr>
                      <td>E</td>
                      <td>- calculated total daily caloric intake</td>
                    </tr>

                    <tr>
                      <td>A</td>
                      <td>- physical activity coefficient</td>
                    </tr>

                    <tr>
                      <td></td>
                      <td>
                        <table>
                          <tr>
                            <td>None</td>
                            <td>1.2</td>
                          </tr>
                          <tr>
                            <td>Occasional workouts</td>
                            <td>1.4</td>
                          </tr>
                          <tr>
                            <td>Frequent workouts</td>
                            <td>1.6</td>
                          </tr>
                          <tr>
                            <td>Frequent and hard workouts</td>
                            <td>1.8</td>
                          </tr>
                          <tr>
                            <td>Athlete</td>
                            <td>2.2</td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td>L</td>
                      <td>- lifestyle coefficient</td>
                    </tr>

                    <tr>
                      <td></td>
                      <td>
                        <table>
                          <tr>
                            <td>Office work</td>
                            <td>1.2</td>
                          </tr>
                          <tr>
                            <td>Mixed work</td>
                            <td>1.5</td>
                          </tr>
                          <tr>
                            <td>Physical work</td>
                            <td>1.8</td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td>m</td>
                      <td>- bodyweight [kg]</td>
                    </tr>
                    <tr>
                      <td>h</td>
                      <td>- height [cm]</td>
                    </tr>
                    <tr>
                      <td>a</td>
                      <td>- age [years]</td>
                    </tr>
                    <tr>
                      <td>s</td>
                      <td>- +5 for men and -161 for women</td>
                    </tr>

                    <tr>
                      <td>T</td>
                      <td>- diet goal [kcal/day]</td>
                    </tr>

                    <tr>
                      <td></td>
                      <td>
                        <table>
                          <tr>
                            <td>Cutting</td>
                            <td>-300</td>
                          </tr>
                          <tr>
                            <td>Maintenance</td>
                            <td>0</td>
                          </tr>
                          <tr>
                            <td>Bulking</td>
                            <td>+300</td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                  </table>
                </p>

                <p>
                  Too low or too high caloric intake may be harmful. Setting caloric, carbohydrates, fats and protein limits should be done in consultation with a doctor or a dietitian.
                  Guidelines on healthy diet are available on the World Health Organization's web page. [<a href="https://www.who.int/health-topics/healthy-diet#tab=tab_2">Link</a>]
                </p>

                <p>
                  "Standard", "Low Carb" and "Keto" diet plans, which can be selected in the Application affect limit macronutrient values in relation to the daily caloric intake requirement calculated by the app. These do not constitute a full nutrition plan.
                  The Application enables overwriting automatically calculated macronutrient limits after selection "Standard" diet plan.
                </p>

                <p>
                  Due to existing contraindications that may applay to ketogenic and low-carbohydrate diets, "Keto" and "Low Carb" options are not to be applied without prior consultation with a doctor or a dietitian.
                </p>
              </li>

            </ol>
          </p>
        </li>

        <li>
          <b>Source of nutrition information</b>

          <p>
            Product data contained in the Application are coming from the Open Food Facts database unless stated otherwise. [<a href="https://world.openfoodfacts.org/">Link</a>]
          </p>
          <p>
            Data accuracy may vary depending on a product. Insulimit sp. z o.o. is not liable for errors in the data.
          </p>
        </li>
      </ol>
    </div>
  );

  const content = i18n.language === 'pl' ? <ContentPl /> : <ContentEn />;
  return (content);
}
